<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>我的收藏</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
        <div class="conten">
          <P class="text">我的收藏页面显示当前用户收藏过的课程。课程查询、课程详情、课程学习均和“精品好课”里的一致。
            如果收藏过的课程被某名师下架了，则在“课程详情页”显示该课程已下架，并且不可评论，不可开始学习，如图所示：
          </P>
         <div><img src="../../../../static/image/62.png"/></div>
      </div>

    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
 .rightContent
    position: relative
    float: right
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
    overflow:auto
  .conten
     padding: 25px 25px 25px 30px
  .titleBar
     color:#000
     font-size:14px
     font-weight:bolder
  .text
     color:#555
     line-height: 25px
     text-indent:2em
     margin-bottom:20px
  .textlittle
    text-indent:4em
  img
   width:80%
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px

</style>



// WEBPACK FOOTER //
// MyCollection.vue?2df42974